import {
  PictureAsPdfOutlined,
  ImageOutlined,
  DescriptionOutlined,
  InsertDriveFileOutlined,
} from "@mui/icons-material";

const WORD_MIMETYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

/**
 * File-format icon for a document's mimetype - distinct from
 * documentTypeIcons.js, which icons the business category (Rechnungen,
 * Policen, …) rather than the file format.
 */
export function iconForMimetype(mimetype) {
  if (mimetype === "application/pdf") {
    return PictureAsPdfOutlined;
  }
  if (mimetype?.startsWith("image/")) {
    return ImageOutlined;
  }
  if (WORD_MIMETYPES.includes(mimetype)) {
    return DescriptionOutlined;
  }
  return InsertDriveFileOutlined;
}

/**
 * Short, human-readable file-format label for a document's mimetype - shown
 * next to its file size, e.g. in the documents table's Dokument column.
 */
export function labelForMimetype(mimetype) {
  if (mimetype === "application/pdf") {
    return "PDF";
  }
  if (WORD_MIMETYPES.includes(mimetype)) {
    return "Word";
  }
  if (mimetype?.startsWith("image/")) {
    return mimetype.split("/")[1]?.toUpperCase() ?? "Bild";
  }
  const subtype = mimetype?.split("/")[1];
  return subtype ? subtype.toUpperCase() : "Datei";
}
